import { NgModule } from '@angular/core';
import {
	Activity,
	AlertCircle,
	Archive,
	ArrowDown,
	ArrowDownUp,
	ArrowRight,
	ArrowUp,
	BadgeCheck,
	Ban,
	Bell,
	BellOff,
	BellRing,
	Bolt,
	Bookmark,
	BookOpen,
	Bot,
	Boxes,
	Briefcase,
	Building,
	Building2,
	Calendar,
	CalendarClock,
	Camera,
	ChartSpline,
	Check,
	CheckCircle,
	CheckSquare,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	Circle,
	CircleAlert,
	CircleArrowRight,
	CircleCheck,
	CircleDashed,
	CircleDollarSign,
	CircleX,
	ClipboardCheck,
	ClipboardList,
	Clock,
	Clock3,
	CloudUpload,
	Code,
	Copy,
	CreditCard,
	Cross,
	Download,
	Edit,
	Ellipsis,
	EllipsisVertical,
	Eye,
	EyeOff,
	File,
	FileArchive,
	FileSpreadsheet,
	FileText,
	FileX,
	Filter,
	Gauge,
	// El Private Talent Desk: el servicio curado de una vacante.
	Gem,
	Ghost,
	Gift,
	GitCompareArrows,
	GraduationCap,
	GripVertical,
	Hash,
	HelpCircle,
	Home,
	Hourglass,
	House,
	IdCard,
	Image,
	Inbox,
	Info,
	Landmark,
	Languages,
	LayoutGrid,
	Link,
	List,
	ListChecks,
	ListCollapse,
	ListFilter,
	Loader,
	LoaderCircle,
	Lock,
	LockKeyhole,
	LogIn,
	LogOut,
	LucideAngularModule,
	Mail,
	MapPin,
	Menu,
	MessageSquare,
	MessageSquareText,
	Mic,
	Minus,
	MoreVertical,
	MoveRight,
	Palette,
	PanelLeftClose,
	PanelLeftOpen,
	Paperclip,
	Pause,
	Pencil,
	PencilRuler,
	Phone,
	Play,
	PlayCircle,
	Plug,
	Plus,
	Receipt,
	RefreshCw,
	RotateCcw,
	Ruler,
	Save,
	Scale,
	ScrollText,
	Search,
	Send,
	Settings,
	ShieldAlert,
	ShieldCheck,
	Sparkles,
	SquareDashedMousePointer,
	Squircle,
	Sun,
	Tag,
	Tickets,
	Timer,
	ToolCase,
	Trash,
	Trash2,
	TrendingUp,
	TriangleAlert,
	Unlock,
	Upload,
	User,
	UserCheck,
	UserPlus,
	UserRound,
	Users,
	UsersRound,
	UserX,
	Video,
	Wallet,
	X,
	Zap,
} from 'lucide-angular';

@NgModule({
	imports: [
		LucideAngularModule.pick({
			Activity,
			AlertCircle,
			ArrowDown,
			ArrowDownUp,
			ArrowRight,
			ArrowUp,
			Archive,
			BadgeCheck,
			Ban,
			Bell,
			BellOff,
			BellRing,
			Bolt,
			Bookmark,
			BookOpen,
			Bot,
			Boxes,
			Briefcase,
			Building,
			Building2,
			Calendar,
			CalendarClock,
			ChartSpline,
			Camera,
			Check,
			CheckCircle,
			CheckSquare,
			ChevronDown,
			ChevronLeft,
			ChevronRight,
			ChevronUp,
			Circle,
			CircleAlert,
			CircleArrowRight,
			CircleCheck,
			CircleDashed,
			CircleDollarSign,
			CircleX,
			ClipboardCheck,
			ClipboardList,
			Clock,
			Clock3,
			CloudUpload,
			Code,
			CreditCard,
			Copy,
			Cross,
			Download,
			Edit,
			Ellipsis,
			EllipsisVertical,
			Eye,
			EyeOff,
			File,
			FileArchive,
			FileSpreadsheet,
			FileText,
			FileX,
			Filter,
			Gauge,
			Gem,
			Gift,
			Ghost,
			GraduationCap,
			GripVertical,
			Hash,
			HelpCircle,
			Home,
			Hourglass,
			House,
			IdCard,
			Image,
			Inbox,
			Info,
			Landmark,
			LayoutGrid,
			Link,
			List,
			ListChecks,
			ListCollapse,
			ListFilter,
			Loader,
			LoaderCircle,
			Lock,
			LockKeyhole,
			Languages,
			LogIn,
			LogOut,
			Mail,
			MapPin,
			Menu,
			MessageSquare,
			MessageSquareText,
			Mic,
			Minus,
			MoreVertical,
			MoveRight,
			Palette,
			PanelLeftClose,
			PanelLeftOpen,
			Paperclip,
			Pause,
			Pencil,
			PencilRuler,
			Ruler,
			Play,
			Phone,
			PlayCircle,
			Plug,
			Plus,
			Receipt,
			RefreshCw,
			RotateCcw,
			Save,
			Scale,
			ScrollText,
			Search,
			Send,
			Settings,
			ShieldAlert,
			ShieldCheck,
			Sparkles,
			SquareDashedMousePointer,
			Squircle,
			Sun,
			Tag,
			Tickets,
			GitCompareArrows,
			Timer,
			ToolCase,
			Trash,
			Trash2,
			TrendingUp,
			TriangleAlert,
			Unlock,
			Upload,
			User,
			UserCheck,
			UserPlus,
			UserRound,
			Users,
			UsersRound,
			UserX,
			Video,
			Wallet,
			X,
			Zap,
		}),
	],
	exports: [LucideAngularModule],
})
export class LucideModule {}
